import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";

interface PrivateRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  redirectPath = "/login",
}) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const urlParams = new URLSearchParams(location.search);
      const domain = urlParams.get("domain");
      const focus = urlParams.get("focus");
      const messageId = urlParams.get("message_id");
      const roleplay = urlParams.get("roleplay");
      const mode = urlParams.get("mode");

      if (domain || focus || messageId || roleplay || mode) {
        const savedParams: {
          domain?: string;
          focus?: string;
          message_id?: string;
          roleplay?: string;
          mode?: string;
        } = {};

        if (domain) savedParams.domain = domain;
        if (focus) savedParams.focus = focus;
        if (messageId) savedParams.message_id = messageId;
        if (roleplay) savedParams.roleplay = roleplay;
        if (mode) savedParams.mode = mode;

        sessionStorage.setItem(
          "pendingChallengeData",
          JSON.stringify(savedParams)
        );
      }
    }
  }, [isAuthenticated, location.search]);

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectPath} replace />
  );
};

export default PrivateRoute;
